import Vue from 'vue'
import Vuex from 'vuex'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/global.css'
import service from '@/api/request'
import { updateAxiosHeader, clearToken, updateUserInfo, clearUserInfo, getUserInfo } from '@/utils/auth'
import { initTheme } from '@/utils/theme'
import { initAudioManager } from '@/components/kyu-player/music/audioManager'
import imageMixin from '@/mixins/image'

// 初始化主题（主题模式 + 主题颜色，统一由 theme.js 管理）
initTheme()

// 初始化音频管理器（向 audioManager 注入 store 引用）
initAudioManager(store)

Vue.prototype.$bus = new Vue()

Vue.prototype.$axios = service
Vue.prototype.$updateToken = updateAxiosHeader
Vue.prototype.$clearToken = clearToken
Vue.prototype.$updateUserInfo = updateUserInfo
Vue.prototype.$clearUserInfo = clearUserInfo
Vue.prototype.$getUserInfo = getUserInfo

Vue.config.productionTip = false
// 全局 z-index 设为 3100，确保 Element UI 弹窗（dialog/popover/dropdown/tooltip）始终在最顶层
// 不会被子组件的固定 z-index 覆盖
Vue.use(ElementUI, { size: 'small', zIndex: 3100 })

Vue.mixin(imageMixin)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
